module.exports = __webpack_public_path__ + "img/icon_add.9b1d554e.png";